import {atom} from 'jotai';
import {makeDict} from '../Utils/common';
import {atomFamily} from 'jotai/utils';
import {atomWithRefresh} from '../Utils/atomWithRefresh';
import {
    getDict,
    getListByModelName,
    ModelItem,
    Status,
} from '../Services/common';
import {getTenantOptions, TenantType} from '../Pages/Tenant/TenantsAll/service';
import {getServicePage} from '../Pages/Service/ServiceAll/service';

import lodash from 'lodash-es';
import {AccountType} from '../Pages/Reptile/Account/service';
import {TagType} from '../Pages/Reptile/WebTag/service';

export const StatusAtom = atom(() =>
    makeDict([
        {label: '停用', value: Status.Freeze},
        {label: '启用', value: Status.Normal},
    ]),
);

export const AccountTypeAtom = atom(() =>
    makeDict([
        {label: '公众号', value: AccountType.Public},
        {label: '订阅号', value: AccountType.Subscription},
        {label: '视频号', value: AccountType.Video},
    ]),
);

export const TenantTypeAtom = atom(() =>
    makeDict([
        {label: 'SaaS云服务', value: TenantType.SaaS},
        {label: '私有化服务', value: TenantType.Private},
    ]),
);

export const TagTypeAtom = atom(() =>
    makeDict([
        {label: '校友信息', value: TagType.Info},
        {label: '校友动态', value: TagType.News},
    ]),
);

export enum ColumnType {
    List = 1,
    Search,
}

export const ColumnTypeAtom = atom(() =>
    makeDict([
        {label: '普通列表', value: ColumnType.List},
        {label: '搜索', value: ColumnType.Search},
    ]),
);

export enum OperateType {
    List = 1,
    Detail,
}

export const OperateTypeAtom = atom(() =>
    makeDict([
        {label: '列表页', value: OperateType.List},
        {label: '内容页', value: OperateType.Detail},
    ]),
);

export enum IsPageType {
    No = 1,
    Yes,
}

export const IsPageTypeAtom = atom(() =>
    makeDict([
        {label: '不是', value: IsPageType.No},
        {label: '是', value: IsPageType.Yes},
    ]),
);

export enum PositionType {
    List,
    ListTitle,
    Url,
    DetailTitle,
    DetailTime,
    DetailContent,
}

export const PositionTypeAtom = atom(() =>
    makeDict([
        {label: '列表块', value: PositionType.List},
        {label: '列表标题', value: PositionType.ListTitle},
        {label: '列表Url', value: PositionType.Url},
        {label: '内容标题', value: PositionType.DetailTitle},
        {label: '内容时间', value: PositionType.DetailTime},
        {label: '内容本体', value: PositionType.DetailContent},
    ]),
);

export enum EnabledStatus {
    Disabled = '0',
    Enabled = '1',
}
export const EnabledStatusAtom = atom(() =>
    makeDict([
        {label: '启用', value: EnabledStatus.Enabled},
        {label: '禁用', value: EnabledStatus.Disabled},
    ]),
);

export const ServiceScopeOptions = async () => {
    const res = await getServicePage({status: Status.Normal});
    return makeDict(
        res.data.map(item => {
            return {
                label: item.name,
                value: item.id,
            };
        }),
    );
};

export const TenantOptionsAtom = atom(async () => {
    const res = await getTenantOptions();
    return makeDict(res);
});

export const dictStore = atomFamily((code: string) =>
    atomWithRefresh(async () => {
        const dictList = await getDict(code);

        return makeDict(
            dictList.map(item => ({
                ...item,
                label: item.name,
                value: item.code,
            })),
        );
    }),
);

export const dictWithCodeStore = atomFamily((code: string) =>
    atomWithRefresh(async get => {
        const dictList = get(dictStore(code));

        return makeDict(
            dictList.data.map(item => ({
                ...item,
                label: `${item.label} (${item.value})`,
                value: item.value,
            })),
        );
    }),
);

export const modelStore = atomFamily(
    (params: {
        code: string;
        bindValue?: keyof ModelItem;
        bindName?: keyof ModelItem;
    }) =>
        atomWithRefresh(async () => {
            const {code, bindValue, bindName} = params;
            const dictList = await getListByModelName(code);
            return makeDict(
                dictList.map(item => ({
                    ...item,
                    label: item[bindName || 'name'],
                    value: item[bindValue || 'code'],
                })),
            );
        }),
    (newParams, oldParams) => {
        return JSON.stringify(newParams) === JSON.stringify(oldParams);
    },
);

export const modelStoreWithCode = atomFamily(
    (params: {
        code: string;
        bindValue?: keyof ModelItem;
        bindName?: keyof ModelItem;
        data?: Record<string, any>;
    }) =>
        atomWithRefresh(async () => {
            const {code, bindValue, bindName, data} = params;
            const dictList = await getListByModelName(code, data);
            return makeDict(
                dictList.map(item => ({
                    ...item,
                    label: `${item[bindName || 'name']}(${item.code})`,
                    value: item[bindValue || 'code'],
                })),
            );
        }),
    (newParams, oldParams) => {
        return JSON.stringify(newParams) === JSON.stringify(oldParams);
    },
);

export function isEmpty(value: any) {
    if (typeof value === 'number') {
        return false;
    }
    return lodash.isEmpty(value);
}
